import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'ws-app-root',
  template: `
    <router-outlet></router-outlet>

    <div
      *ngIf="isSandbox"
      class="fixed z-[9999] top-0 left-0 w-full h-0.5 bg-primary-500 flex justify-center items-baseline"
    >
      <div class="px-2 py-0.5 text-xs text-base-white italic rounded-b-md bg-primary-500">sandbox</div>
    </div>
  `,
})
export class AppComponent {
  protected isSandbox = environment.apiMode === 'sandbox';
}
